export default __webpack_public_path__ + "static/spotify.url-eeb05f0dbf3ad308ae8279ead0fee55d.svg";